<template>
  <div>
    <strong>{{ cancellationName }}</strong>
    <div v-if="value.old_price_lists != null">
      <b-badge>{{ value.old_price_lists | currency }}</b-badge>
      &gt;
      <b-badge variant="primary">
        {{ value.new_price_lists | currency }}
      </b-badge>
      <small class="ml-2 text-muted">Price lists</small>
    </div>
    <div v-if="value.old_price_selling != null">
      <b-badge>{{ value.old_price_selling | currency }}</b-badge>
      &gt;
      <b-badge variant="primary">
        {{ value.new_price_selling | currency }}
      </b-badge>
      <small class="ml-2 text-muted">Price selling</small>
    </div>
    <div v-if="value.old_price_purchasing != null">
      <b-badge>{{ value.old_price_purchasing | currency }}</b-badge>
      &gt;
      <b-badge variant="primary">
        {{ value.new_price_purchasing | currency }}
      </b-badge>
      <small class="ml-2 text-muted">Price purchasing</small>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { CondOperator, RequestQueryBuilder } from '@dataui/crud-request';

export async function fetchCancellations({ job: { cancellations } }) {
  if (cancellations.length == 0) {
    return [];
  }

  const queryString = RequestQueryBuilder.create({
    join: [
      {
        field: 'cancellationReason.translations',
        select: ['locale', 'description'],
      },
    ],
    filter: {
      field: `id`,
      operator: CondOperator.IN,
      value: cancellations.map(
        ({ cancellation_reason_opportunity_id }) =>
          cancellation_reason_opportunity_id,
      ),
    },
  }).query();

  return await axios
    .get(`/data-api/cancellation-reason-opportunity/?${queryString}`)
    .then(({ data }) =>
      cancellations
        .map((value) => {
          const definition = data.find(
            ({ id }) => id == value.cancellation_reason_opportunity_id,
          );

          return definition
            ? {
                time: new Date(value.created_date),
                value: {
                  ...value,
                  definition,
                },
              }
            : null;
        })
        .filter(Boolean),
    );
}

export default {
  props: {
    value: Object,
  },
  computed: {
    ...mapGetters(['locale']),
    cancellationName() {
      let name = this.value.definition.cancellationReason.name;
      let desc = this.value.definition.cancellationReason.translations.find(
        ({ locale }) => locale == this.locale,
      )?.description;
      return `${name} - ${desc}`;
    },
  },
};
</script>
